import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { BaseTagFragment } from "graphql.generated";

import { ActionSource } from "../../../state/action-sources";

export const JobTagActions = createActionGroup({
  source: ActionSource.JOB_TAGS,
  events: {
    'In Place Activated': emptyProps(),
    'In Place Deactivated': emptyProps(),
    'Job Tags Loaded': props<{ tags: BaseTagFragment[] }>(),
    'Tag Autocomplete Search Fired': props<{ query: string }>(),
    'Search Tags Success': props<{ tagSuggestions: BaseTagFragment[] }>(),
    'Search Tags Error': props<{ error: Error }>(),
    'Tag Selected': props<{ tag: BaseTagFragment }>(),
    'Tag Unselected': props<{ tag: BaseTagFragment }>(),
    'Set Tags Success': props<{ tags: BaseTagFragment[]; jobId: string }>(),
    'Set Tags Error': props<{ error: Error }>(),
    'Fetch Default Tags Success': props<{ defaultTags: BaseTagFragment[] }>(),
    'Fetch Default Tags Error': props<{ error: Error }>(),
  }
});
